import React, { useEffect, useState } from 'react';
import { CheckBox, SelectInput } from '../../../Components';
import './Index.css';
const pricing = {
    'White Coffee Mug': 140,
    'Black Patch Coffee Mug': 180,
    'Magic Mug': 220,
    'Tea Mug': 140,
    'Glow In Dark Mug': 260,
    'Beer Mug': 325,
    'Sipper Bottle': { '500ml': 225, '600ml': 250, '750ml': 275 },
    Tile: { '4x4': 105, '6x6': 165, '6x8': 205, '8x8': 225, '8x10': 255, '8x12': 275 },
    'Fridge Magnet': 115,
    'Heart Puzzle': 375,
    'Door Hanger': 115,
    Coaster: 55,
    'Mouse Pad': 90,
    Poster: 90,
    colorInside: 150,
};
const Index = ({ product, colorInside, deliverycost }) => {
    const [variantPrice, setVariant] = useState('null');
    const [colorInsidePrice, setColorInsidePrice] = useState(0);

    const neckLabelCheckhandler = (name, currentState) => {
        if (currentState) {
            setColorInsidePrice(0);
        } else {
            setColorInsidePrice(pricing['colorInside']);
        }
    };
    useEffect(() => {
        setVariant('null');
    }, [product]);
    return (
        <>
            <p className="product_detail">Calculate the price of the {product} based on the Printing of the design:</p>
            {typeof pricing[product] === 'number' ? (
                <p className="item_printing_detail">
                    Cost of printing of <b>{product}</b> is:{' '}
                    <b>
                        {pricing[product] +
                            colorInsidePrice +
                            deliverycost +
                            (pricing[product] + colorInsidePrice) * 0.05}{' '}
                        ₹
                    </b>
                    .
                </p>
            ) : typeof pricing[product] === 'object' ? (
                <div className="item_printing_detail_options">
                    <SelectInput
                        label="Variant"
                        outlined={true}
                        value={variantPrice}
                        changeHandler={(e) => {
                            setVariant(e.target.value);
                        }}
                        options={[
                            { name: `Select a Variant of ${product}`, value: 'null' },
                            ...Object.keys(pricing[product]).map((ele) => {
                                return {
                                    name: ele,
                                    value: pricing[product][ele],
                                };
                            }),
                        ]}
                    />
                </div>
            ) : (
                ''
            )}

            {colorInside && (
                <div style={{ display: 'flex', flexDirection: 'column', width: 'calc(100% - 1rem)' }}>
                    <CheckBox
                        style={{ marginBottom: '0', flex: 1 }}
                        handleChange={neckLabelCheckhandler}
                        name="colorInside"
                        value="colorInside"
                        labeling={`Color inside of ${product}?`}
                        checked={false}
                    />
                    <p
                        style={{ marginBottom: '2rem', fontSize: '8px !important', fontWeight: 'bold !important' }}
                        className="input_info"
                    >
                        Single Color will be printed inside.
                    </p>
                </div>
            )}
            {variantPrice !== 'null' && (
                <p className="item_printing_detail">
                    Cost of printing of <b>{product}</b> of selected variant is:{' '}
                    <b>{variantPrice + colorInsidePrice + deliverycost + (variantPrice + colorInsidePrice) * 0.05} ₹</b>
                    .
                </p>
            )}
        </>
    );
};

export default Index;
